{{#each paths}}
   <div data-region="{{../cid}}-{{id}}-blocks"></div>
{{/each}}